/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:24:05                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-12 17:07:00                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * UnscheludedDrawer: drawer for events no scheduled 
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
/***/

/* Components */
import WorkorderDashCard from "../../../components/data/workorder/WorkorderDashCard";
/***/

/**
* UnscheludedDrawer: drawer for events no scheduled
* @param times - times list
*/
export default function UnscheludedDrawer({
  workorders = [],
  onTimeClick
}: {
  workorders: EasyTech.Workorder[],
  onTimeClick: (el: EasyTech.Workorder) => void
}) {
  const { t } = useTranslation();
  
  return (
    <div>
        <>
          <Typography variant="h5">
            {t("planification:calendar:unscheluded:title")}
          </Typography>
          
          <div className="flex flex-col gap-2 mt-3">
            {workorders.map((el, i) => <WorkorderDashCard workorder={el} onClick={() => onTimeClick(el)} key={"unsheduled-inter-"+i}/>)}
            {workorders.length === 0 && <i>{t("planification:calendar:unscheluded:noData")}</i>}
          </div>
        </>
    </div>
  );
}
/***/
